import { render, staticRenderFns } from "./submitButton.vue?vue&type=template&id=95c23fbc"
import script from "./submitButton.vue?vue&type=script&lang=js"
export * from "./submitButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports